export const smallBlocksStyle = {
	wrapper: {
		display: 'flex',
		gap: '16px',
	},
	item: {
		width: '25%',
		height: '76px',
		padding: '12px',
		borderRadius: '8px',
		backgroundColor: 'var(--default-white)',
		boxShadow: 'var(--box-shadow--1)',
	},
	topBlock: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		height: '32px',
	},
	name: {
		fontSize: '14px',
		fontWeight: '400',
		lineHeight: '18px',
		color: 'var(--neutral-300)',
	},
	data: {
		fontSize: '20px',
		fontWeight: '700',
		lineHeight: '24px',
		color: 'var(--neutral-900)',
	},
};
